var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrello({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9v27a3 3 0 003 3h9a3 3 0 003-3V9a3 3 0 00-3-3H9a3 3 0 00-3 3zm21 0v15a3 3 0 003 3h9a3 3 0 003-3V9a3 3 0 00-3-3h-9a3 3 0 00-3 3zM6 0C2.686 0 0 2.688 0 6v36c0 3.313 2.688 6 6 6h36c3.314 0 6-2.688 6-6V6c0-3.313-2.688-6-6-6H6z",
    fill: "#007AC2",
    fillRule: "evenodd"
  })));
}

export default SvgTrello;